import { ServicesURL, downloadBlobFile, uploadFile } from "@utils/utilsApi";
import { MethodType } from "src/services/type";
import {
  MassiveUploadResult,
  toMassiveUploadResult,
} from "./massiveUploadResult";

export interface MassiveStatusTarget {
  corporateId: string | number;
  objectId: string | number;
}

const TEMPLATE_FILENAME = "FORCE-STATUS-TEMPLATE.csv";

const buildUrl = (
  base: string,
  { corporateId, objectId }: MassiveStatusTarget,
): string =>
  `${base}?${new URLSearchParams({
    corporateId: String(corporateId),
    objectId: String(objectId),
  }).toString()}`;

export const downloadMassiveStatusTemplate = (target: MassiveStatusTarget) =>
  downloadBlobFile(
    buildUrl(ServicesURL.getForceStatusTemplate, target),
    null,
    TEMPLATE_FILENAME,
    MethodType.GET,
  );

export const uploadMassiveStatusFile = async (
  target: MassiveStatusTarget,
  file: File,
): Promise<MassiveUploadResult> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await uploadFile(
    buildUrl(ServicesURL.postForceStatusUpload, target),
    formData,
  );
  return toMassiveUploadResult(response);
};
